/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ConfirmModalConfigurationModel} from '../../../../shared/confirm-modal/confirm-modal/models/confirm-modal-configuration.model';
import {AlertNotificationSeverity} from '../../../../alert-notification-severity.model';

const deleteAlertConfigModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Delete alert',
    body: {
        title: 'By deleting this Alert you will not be able to withdraw',
        manualChecks: {options: []}
    },
    primaryActionTitle: 'Delete',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.ERROR
};

/**
 * Variable to export configurations
 */
const alertConfigModals: {
    deleteAlertConfig: ConfirmModalConfigurationModel;
} = {
    deleteAlertConfig: deleteAlertConfigModalConfiguration
};

export default alertConfigModals;
